export default __webpack_public_path__ + "static/media/EmailIcon.d8d82f45.svg";